import React, { useState, useEffect } from 'react';
import { Navbar, NavbarToggler, Collapse, Nav, NavItem } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useReload } from '../PageState';
import { useLogin, useLogout, useUser, useSetLanguage } from '../UserState';

const LANGUAGES = [
	{ value: 'de', label: '🇩🇪 Deutsch' },
	{ value: 'en', label: '🇬🇧 English' },
	{ value: 'es', label: '🇪🇸 Español' },
	{ value: 'fr', label: '🇫🇷 Français' },
	{ value: 'it', label: '🇮🇹 Italiano' },
	{ value: 'nl', label: '🇳🇱 Nederlands' },
	{ value: 'pl', label: '🇵🇱 Polski' }
];

export default function Header({ updateHeaders, id }) {
	const { t, i18n } = useTranslation();
	const login = useLogin();
	const logout = useLogout();
	const { email, loggedIn } = useUser().user;
	const [open, setOpen] = useState(false);
	const location = useLocation();
	const setLanguage = useSetLanguage();
	useReload(id, updateHeaders);
	useEffect(() => {
		setOpen(false);
	}, [location]);
	return <header>
		<Navbar expand="sm" fixed="top" className="bg-white">
			<Link to="/" className="navbar-brand">
				<img src="https://api.ptmd.nl/rest/images/v1/original/logo/logo" className="brand-icon" alt="PTMD" />
			</Link>
			<div className="navbar-brand ptmd-nav-center">
				<div className="ptmd-nav-lang">
					<Select options={LANGUAGES} placeholder={t('Language')} value={LANGUAGES.find(o => i18n.language.startsWith(o.value))} onChange={async e => {
						try {
							await setLanguage(e.value);
							updateHeaders();
						} catch(err) {
							console.error('Failed to change language', err);
						}
					}} />
				</div>
			</div>
			<NavbarToggler onClick={() => setOpen(!open)} />
			<Collapse isOpen={open} navbar className="ptmd-nav-collapse">
				<Nav className="ml-auto" navbar>
					<NavItem>
						{loggedIn ?
							<Link className="nav-link" to="/" onClick={logout}>
								{email}
								<img src="/logout.png" alt={t('Logout')} className="brand-icon ml-1" />
							</Link>
							: <Link className="nav-link" to="/" onClick={() => login(true)}>{t('Login')}</Link>}
					</NavItem>
				</Nav>
			</Collapse>
		</Navbar>
	</header>;
}
